import type { TeachersType } from "@/api_types/school";
import FetchService from "@/services/fetch.service";
import { asyncComputed } from "@/utils/asyncComputed";
import { sort } from "@/utils/sort";
import { defineStore } from "pinia";

export const useTeachers = defineStore("directory/teachers", {
  state: () => {
    return {
      teachers: asyncComputed(
        async (controller) => {
          const res = (await FetchService.fetchData(
            "/teachers",
            "get",
            undefined,
            undefined,
            controller
          )) as TeachersType;

          return sort(res || [], (i) => i.teacher_fname + i.teacher_lname);
        },
        [],
        undefined,
        false,
        []
      )
    };
  },
  actions: {
    async getTeacher(teacher_uid: string) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}`, "get");
      return res;
    },
    async attach(teacher_uid: string, relationship: string, uid: string) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/attach`, "put", {
        [relationship]: uid
      });
      return res;
    },
    async detach(teacher_uid: string, relationship: string, uids: string | string[]) {
      const payload = Array.isArray(uids) ? { [relationship]: uids } : { [relationship]: [uids] };
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/detach`, "put", payload);
      return res;
    },
    async linkStudent(teacher_uid, student_uid): Promise<any> {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/attach`, "put", {
      children_uid: student_uid
      });
      return res;
    },
    async linkParent(teacher_uid, parent_uid) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/attach`, "put", {
        parent_uid: parent_uid
      });
      return res;
    },
    async linkTeam(teacher_uid, team_uid) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/attach`, "put", {    
        team_uid: team_uid
      });
      return res; 
    },
    async linkClass(teacher_uid, class_uid) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/attach`, "put", {
        class_id: class_uid
      });
      return res;
    },
    async linkParenTeacher(parent_uid, children_uid, teacher_uid) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/attach`, "put", {
        children_uid: children_uid,
        parent_uid: parent_uid
      });
      return res;
    },
    async deleteParenTeacherRelation(parent_uid, children_uid, teacher_uid) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/detach`, "put", {
        children_uid,
        parent_uid
      });
      return res;
    },
    async resetPassword(teacher_uid, password){
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}/resetPassword`, "put",{"password":password});
      return res;
    },
    async updateTeacher(teacher_uid: string, teacherData: Partial<TeachersType[number]>) {
      const res = await FetchService.fetchData(`/teachers/${teacher_uid}`, "put", teacherData);
      if (res.teacher) {
        this.teachers.data.map((t) => {
          if (t.uid === teacher_uid) Object.assign(t, res.teacher);
        });
      }
      return res;
    },
    async createTeacher(teacherData: Partial<TeachersType[number]>) {
      const res = await FetchService.fetchData(`/teachers`, "post", teacherData);
      console.log(res);

      if (res.teacher_fname) {
        res.deleted = false;
        this.teachers.data = sort(
          [...this.teachers.data, res],
          (i) => i.teacher_fname + i.teacher_lname
        );
        return true;
      }
      return false;
    }
  }
});

export default useTeachers;
